import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Input from '../../Input';
import { FilterTypes } from '../Components';

class InputFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
    this.refFilterInput = createRef();
  }

  clear = () => {
    this.refFilterInput.current.clear();
    this.setState({ value: '' });
  }

  handleKeyUp = (evt) => {
    const { item } = this.props;
    const { value } = evt.target;
    if (item.type === 'number' && isNaN(value)) {
      this.clear();
      return;
    }
    this.notifica(evt);
  };

  onChange = (evt) => {
    this.setState({ value: evt.target.value });
  }

  notifica = (evt) => {
    const { item } = this.props;
    this.notifyAddFilter(
      item.propertyName,
      item.queryOption,
      evt,
      null,
      null,
      FilterTypes.INPUT,
      item.customFilter,
    );
  };

  notifyAddFilter = (...filter) => {
    const { addFilter } = this.props;
    addFilter && addFilter(...filter);
  };

  render() {
    const {
      addFilter,
      item,
      customFilter,
      ...others
    } = this.props;
    const { value } = this.state;
    return (
      <div className="filter__campoRicerca" style={item.width && { width: item.width.toString() }}>
        <div className="input">
          <Input
            onKeyUp={this.handleKeyUp}
            onChange={this.onChange}
            ref={this.refFilterInput}
            title={item.description}
            value={value}
            {...others}
          />
        </div>
      </div>
    );
  }
}

InputFilter.propTypes = {
  /** Callback invocata all'aggiunta di un termine di filtro */
  addFilter: PropTypes.func.isRequired,
  /** Descrittore del filtro da applicare */
  item: PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
  }).isRequired,
};

export default InputFilter;
